import {Component, inject, OnInit, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {RouterOutlet} from '@angular/router';
import {SpinnerOverlay} from './shared/components/spinner-overlay/spinner-overlay';
import {TrackingWebsocket} from './services/websockets/traking-websocket';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SpinnerOverlay],
  template: `
    <app-spinner-overlay/>
    <router-outlet/>
  `,
  styleUrl: './app.scss'
})
export class App implements OnInit {


  private trackingWs = inject(TrackingWebsocket);
  private platformId = inject(PLATFORM_ID);

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      const savedOrderId = localStorage.getItem('orderId');
      const savedCustomerId = localStorage.getItem('customerId');


      if (savedOrderId && savedCustomerId) {

        this.trackingWs.connect(savedOrderId, savedCustomerId);
      }
    }
  }
}
